export { Utils }

class Utils {
    /** @returns {number} values between -1 and 1. */
    static basicValue(value, rangeMax) {
        return 2 * value / rangeMax - 1
    }

    /** @returns {number} random values between -1 and 1. */
    static basicRandomValue() {
        // pseudo-random numbers are totally fine here.
        // eslint-disable-next-line sonarjs/pseudo-random
        return this.basicValue(Math.random(), 1)
    }

    /**
     * @param {number} to the value that is the excluded upper boundary
     * @param {number} [from=0]  from the included value to start with
     * @param {number} [from=1] step from one value to the other
     * @returns an array prepopulated with numeric values
     */
    static range(to, from = 0, step = 1) {
        return Array.from(
            { length: Math.ceil((to - from) / step) },
            (_, i) => from + i * step
        )
    }

    static easeInOut(slopeIn = 2, slopeOut = slopeIn || 2) {
        return (t) => t < .5
            ? Math.pow(2, slopeIn - 1) * Math.pow(t, slopeIn)
            : 1 - Math.pow(-2 * t + 2, slopeOut) / 2
    }
}